import React, { Suspense } from 'react';

import { ReactComponent as IconLock14 } from '../../icons/14/lock.svg';
import { ReactComponent as IconArchive16 } from '../../icons/16/archive.svg';
import { ReactComponent as IconBookmark16 } from '../../icons/16/bookmark.svg';
import { ReactComponent as IconBoost16 } from '../../icons/16/boost.svg';
import { ReactComponent as IconCheck16 } from '../../icons/16/check.svg';
import { ReactComponent as IconChevronDown16 } from '../../icons/16/chevron-down.svg';
import { ReactComponent as IconChevronLeft16 } from '../../icons/16/chevron-left.svg';
import { ReactComponent as IconChevronRight16 } from '../../icons/16/chevron-right.svg';
import { ReactComponent as IconChevronUp16 } from '../../icons/16/chevron-up.svg';
import { ReactComponent as IconClock16 } from '../../icons/16/clock.svg';
import { ReactComponent as IconClose16 } from '../../icons/16/close.svg';
import { ReactComponent as IconColumns16 } from '../../icons/16/columns.svg';
import { ReactComponent as IconComment16 } from '../../icons/16/comment.svg';
import { ReactComponent as IconConfig16 } from '../../icons/16/config.svg';
import { ReactComponent as IconControls16 } from '../../icons/16/controls.svg';
import { ReactComponent as IconCopyLink16 } from '../../icons/16/copy-link.svg';
import { ReactComponent as IconCopy16 } from '../../icons/16/copy.svg';
import { ReactComponent as IconCsv16 } from '../../icons/16/csv.svg';
import { ReactComponent as IconDashboard16 } from '../../icons/16/dashboard.svg';
import { ReactComponent as IconDate16 } from '../../icons/16/date.svg';
import { ReactComponent as IconDelete16 } from '../../icons/16/delete.svg';
import { ReactComponent as IconDeselectAll16 } from '../../icons/16/deselect-all.svg';
import { ReactComponent as IconDownArrow16 } from '../../icons/16/down-arrow.svg';
import { ReactComponent as IconDownload16 } from '../../icons/16/download.svg';
import { ReactComponent as IconDrag16 } from '../../icons/16/drag.svg';
import { ReactComponent as IconEdit16 } from '../../icons/16/edit.svg';
import { ReactComponent as IconErrorStatus16 } from '../../icons/16/error_status.svg';
import { ReactComponent as IconExpand16 } from '../../icons/16/expand.svg';
import { ReactComponent as IconExports16 } from '../../icons/16/exports.svg';
import { ReactComponent as IconExternalLink16 } from '../../icons/16/external-link.svg';
import { ReactComponent as IconEyeHide16 } from '../../icons/16/eye-hide.svg';
import { ReactComponent as IconEyeShow16 } from '../../icons/16/eye-show.svg';
import { ReactComponent as IconFile16 } from '../../icons/16/file.svg';
import { ReactComponent as IconFilterList16 } from '../../icons/16/filter-list.svg';
import { ReactComponent as IconFilterSliders16 } from '../../icons/16/filter-sliders.svg';
import { ReactComponent as IconFilters16 } from '../../icons/16/filters.svg';
import { ReactComponent as IconFlag16 } from '../../icons/16/flag.svg';
import { ReactComponent as IconFolder16 } from '../../icons/16/folder.svg';
import { ReactComponent as IconGraph16 } from '../../icons/16/graph.svg';
import { ReactComponent as IconHandGrab16 } from '../../icons/16/hand-grab.svg';
import { ReactComponent as IconHome16 } from '../../icons/16/home.svg';
import { ReactComponent as IconHorizontalEllipsis16 } from '../../icons/16/horizontal-ellipsis.svg';
import { ReactComponent as IconInfo16 } from '../../icons/16/info.svg';
import { ReactComponent as IconInfoStatus16 } from '../../icons/16/info_status.svg';
import { ReactComponent as IconLeftArrow16 } from '../../icons/16/left-arrow.svg';
import { ReactComponent as IconLinkedin16 } from '../../icons/16/linkedin.svg';
import { ReactComponent as IconListAdd16 } from '../../icons/16/list-add.svg';
import { ReactComponent as IconListCheck16 } from '../../icons/16/list-check.svg';
import { ReactComponent as IconList16 } from '../../icons/16/list.svg';
import { ReactComponent as IconLock16 } from '../../icons/16/lock.svg';
import { ReactComponent as IconLogOut16 } from '../../icons/16/log-out.svg';
import { ReactComponent as IconMail16 } from '../../icons/16/mail.svg';
import { ReactComponent as IconMapperSuggestions16 } from '../../icons/16/mapper-suggestions.svg';
import { ReactComponent as IconMenu16 } from '../../icons/16/menu.svg';
import { ReactComponent as IconMerge16 } from '../../icons/16/merge.svg';
import { ReactComponent as IconMinus16 } from '../../icons/16/minus.svg';
import { ReactComponent as IconMoreInfo16 } from '../../icons/16/more-info.svg';
import { ReactComponent as IconNotes16 } from '../../icons/16/notes.svg';
import { ReactComponent as IconNotifications16 } from '../../icons/16/notifications.svg';
import { ReactComponent as IconPencil16 } from '../../icons/16/pencil.svg';
import { ReactComponent as IconPlusCircle16 } from '../../icons/16/plus-circle.svg';
import { ReactComponent as IconPlus16 } from '../../icons/16/plus.svg';
import { ReactComponent as IconRedo16 } from '../../icons/16/redo.svg';
import { ReactComponent as IconRefresh16 } from '../../icons/16/refresh.svg';
import { ReactComponent as IconRightArrow16 } from '../../icons/16/right-arrow.svg';
import { ReactComponent as IconRolesPermissions16 } from '../../icons/16/roles-permissions.svg';
import { ReactComponent as IconSave16 } from '../../icons/16/save.svg';
import { ReactComponent as IconSearch16 } from '../../icons/16/search.svg';
import { ReactComponent as IconSelectAll16 } from '../../icons/16/select-all.svg';
import { ReactComponent as IconSettings16 } from '../../icons/16/settings.svg';
import { ReactComponent as IconShare16 } from '../../icons/16/share.svg';
import { ReactComponent as IconSortAsc16 } from '../../icons/16/sort-asc.svg';
import { ReactComponent as IconSortDes16 } from '../../icons/16/sort-des.svg';
import { ReactComponent as IconSort16 } from '../../icons/16/sort.svg';
import { ReactComponent as IconStarFilled16 } from '../../icons/16/star-filled.svg';
import { ReactComponent as IconStarUnfilled16 } from '../../icons/16/star-unfilled.svg';
import { ReactComponent as IconSuccessStatus16 } from '../../icons/16/success_status.svg';
import { ReactComponent as IconSuitcase16 } from '../../icons/16/suitcase.svg';
import { ReactComponent as IconSwitchAcc16 } from '../../icons/16/switch-acc.svg';
import { ReactComponent as IconTag16 } from '../../icons/16/tag.svg';
import { ReactComponent as IconTeamOutbound16 } from '../../icons/16/team-outbound.svg';
import { ReactComponent as IconTeamPremium16 } from '../../icons/16/team-premium.svg';
import { ReactComponent as IconTeamUnverified16 } from '../../icons/16/team-unverified.svg';
import { ReactComponent as IconTeamVerified16 } from '../../icons/16/team-verified.svg';
import { ReactComponent as IconUnarchive16 } from '../../icons/16/unarchive.svg';
import { ReactComponent as IconUnmap16 } from '../../icons/16/unmap.svg';
import { ReactComponent as IconUnlock16 } from '../../icons/16/unlock.svg';
import { ReactComponent as IconUpArrow16 } from '../../icons/16/up-arrow.svg';
import { ReactComponent as IconUpload16 } from '../../icons/16/upload.svg';
import { ReactComponent as IconUserAttribute16 } from '../../icons/16/user-attribute.svg';
import { ReactComponent as IconUserCircle16 } from '../../icons/16/user-circle.svg';
import { ReactComponent as IconUserMinus16 } from '../../icons/16/user-minus.svg';
import { ReactComponent as IconUserPlus16 } from '../../icons/16/user-plus.svg';
import { ReactComponent as IconUser16 } from '../../icons/16/user.svg';
import { ReactComponent as IconUsersGroup16 } from '../../icons/16/users-group.svg';
import { ReactComponent as IconVerticalEllipsis16 } from '../../icons/16/vertical-ellipsis.svg';
import { ReactComponent as IconWarning16 } from '../../icons/16/warning.svg';
import { ReactComponent as IconWarningStatus16 } from '../../icons/16/warning_status.svg';
import { ReactComponent as IconFacebook16 } from '../../icons/16/facebook.svg';
import { ReactComponent as IconX16 } from '../../icons/16/x.svg';
import { ReactComponent as IconWindfall16 } from '../../icons/16/windfall.svg';
import { ReactComponent as IconArchive20 } from '../../icons/20/archive.svg';
import { ReactComponent as IconBookmark20 } from '../../icons/20/bookmark.svg';
import { ReactComponent as IconBoost20 } from '../../icons/20/boost.svg';
import { ReactComponent as IconCheck20 } from '../../icons/20/check.svg';
import { ReactComponent as IconChevronDown20 } from '../../icons/20/chevron-down.svg';
import { ReactComponent as IconChevronLeft20 } from '../../icons/20/chevron-left.svg';
import { ReactComponent as IconChevronRight20 } from '../../icons/20/chevron-right.svg';
import { ReactComponent as IconChevronUp20 } from '../../icons/20/chevron-up.svg';
import { ReactComponent as IconClock20 } from '../../icons/20/clock.svg';
import { ReactComponent as IconClose20 } from '../../icons/20/close.svg';
import { ReactComponent as IconColumns20 } from '../../icons/20/columns.svg';
import { ReactComponent as IconComment20 } from '../../icons/20/comment.svg';
import { ReactComponent as IconConfig20 } from '../../icons/20/config.svg';
import { ReactComponent as IconControls20 } from '../../icons/20/controls.svg';
import { ReactComponent as IconCopy20 } from '../../icons/20/copy.svg';
import { ReactComponent as IconCopyLink20 } from '../../icons/20/copy-link.svg';
import { ReactComponent as IconDashboard20 } from '../../icons/20/dashboard.svg';
import { ReactComponent as IconDate20 } from '../../icons/20/date.svg';
import { ReactComponent as IconDelete20 } from '../../icons/20/delete.svg';
import { ReactComponent as IconDownArrow20 } from '../../icons/20/down-arrow.svg';
import { ReactComponent as IconDownload20 } from '../../icons/20/download.svg';
import { ReactComponent as IconDrag20 } from '../../icons/20/drag.svg';
import { ReactComponent as IconEdit20 } from '../../icons/20/edit.svg';
import { ReactComponent as IconExpand20 } from '../../icons/20/expand.svg';
import { ReactComponent as IconExports20 } from '../../icons/20/exports.svg';
import { ReactComponent as IconExternalLink20 } from '../../icons/20/external-link.svg';
import { ReactComponent as IconEyeHide20 } from '../../icons/20/eye-hide.svg';
import { ReactComponent as IconEyeShow20 } from '../../icons/20/eye-show.svg';
import { ReactComponent as IconFile20 } from '../../icons/20/file.svg';
import { ReactComponent as IconFilterList20 } from '../../icons/20/filter-list.svg';
import { ReactComponent as IconFilters20 } from '../../icons/20/filters.svg';
import { ReactComponent as IconFilterSliders20 } from '../../icons/20/filter-sliders.svg';
import { ReactComponent as IconFlag20 } from '../../icons/20/flag.svg';
import { ReactComponent as IconFolder20 } from '../../icons/20/folder.svg';
import { ReactComponent as IconGraph20 } from '../../icons/20/graph.svg';
import { ReactComponent as IconHandGrab20 } from '../../icons/20/hand-grab.svg';
import { ReactComponent as IconHome20 } from '../../icons/20/home.svg';
import { ReactComponent as IconHorizontalEllipsis20 } from '../../icons/20/horizontal-ellipsis.svg';
import { ReactComponent as IconLeftArrow20 } from '../../icons/20/left-arrow.svg';
import { ReactComponent as IconList20 } from '../../icons/20/list.svg';
import { ReactComponent as IconListAdd20 } from '../../icons/20/list-add.svg';
import { ReactComponent as IconListCheck20 } from '../../icons/20/list-check.svg';
import { ReactComponent as IconLock20 } from '../../icons/20/lock.svg';
import { ReactComponent as IconLogOut20 } from '../../icons/20/log-out.svg';
import { ReactComponent as IconMail20 } from '../../icons/20/mail.svg';
import { ReactComponent as IconMenu20 } from '../../icons/20/menu.svg';
import { ReactComponent as IconMerge20 } from '../../icons/20/merge.svg';
import { ReactComponent as IconMinus20 } from '../../icons/20/minus.svg';
import { ReactComponent as IconMoreInfo20 } from '../../icons/20/more-info.svg';
import { ReactComponent as IconNotes20 } from '../../icons/20/notes.svg';
import { ReactComponent as IconNotifications20 } from '../../icons/20/notifications.svg';
import { ReactComponent as IconPencil20 } from '../../icons/20/pencil.svg';
import { ReactComponent as IconPlus20 } from '../../icons/20/plus.svg';
import { ReactComponent as IconPlusCircle20 } from '../../icons/20/plus-circle.svg';
import { ReactComponent as IconRedo20 } from '../../icons/20/redo.svg';
import { ReactComponent as IconRefresh20 } from '../../icons/20/refresh.svg';
import { ReactComponent as IconRightArrow20 } from '../../icons/20/right-arrow.svg';
import { ReactComponent as IconSave20 } from '../../icons/20/save.svg';
import { ReactComponent as IconSearch20 } from '../../icons/20/search.svg';
import { ReactComponent as IconSettings20 } from '../../icons/20/settings.svg';
import { ReactComponent as IconShare20 } from '../../icons/20/share.svg';
import { ReactComponent as IconSort20 } from '../../icons/20/sort.svg';
import { ReactComponent as IconSortAsc20 } from '../../icons/20/sort-asc.svg';
import { ReactComponent as IconSortDes20 } from '../../icons/20/sort-des.svg';
import { ReactComponent as IconStarFilled20 } from '../../icons/20/star-filled.svg';
import { ReactComponent as IconStarUnfilled20 } from '../../icons/20/star-unfilled.svg';
import { ReactComponent as IconSwitchAcc20 } from '../../icons/20/switch-acc.svg';
import { ReactComponent as IconTag20 } from '../../icons/20/tag.svg';
import { ReactComponent as IconUnarchive20 } from '../../icons/20/unarchive.svg';
import { ReactComponent as IconUnlock20 } from '../../icons/20/unlock.svg';
import { ReactComponent as IconUpArrow20 } from '../../icons/20/up-arrow.svg';
import { ReactComponent as IconUpload20 } from '../../icons/20/upload.svg';
import { ReactComponent as IconUser20 } from '../../icons/20/user.svg';
import { ReactComponent as IconUserCircle20 } from '../../icons/20/user-circle.svg';
import { ReactComponent as IconUserMinus20 } from '../../icons/20/user-minus.svg';
import { ReactComponent as IconUserPlus20 } from '../../icons/20/user-plus.svg';
import { ReactComponent as IconUsersGroup20 } from '../../icons/20/users-group.svg';
import { ReactComponent as IconVerticalEllipsis20 } from '../../icons/20/vertical-ellipsis.svg';
import { ReactComponent as IconArchive24 } from '../../icons/24/archive.svg';
import { ReactComponent as IconBookmark24 } from '../../icons/24/bookmark.svg';
import { ReactComponent as IconBoost24 } from '../../icons/24/boost.svg';
import { ReactComponent as IconCheck24 } from '../../icons/24/check.svg';
import { ReactComponent as IconChevronDown24 } from '../../icons/24/chevron-down.svg';
import { ReactComponent as IconChevronLeft24 } from '../../icons/24/chevron-left.svg';
import { ReactComponent as IconChevronRight24 } from '../../icons/24/chevron-right.svg';
import { ReactComponent as IconChevronUp24 } from '../../icons/24/chevron-up.svg';
import { ReactComponent as IconClock24 } from '../../icons/24/clock.svg';
import { ReactComponent as IconClose24 } from '../../icons/24/close.svg';
import { ReactComponent as IconColumns24 } from '../../icons/24/columns.svg';
import { ReactComponent as IconComment24 } from '../../icons/24/comment.svg';
import { ReactComponent as IconConfig24 } from '../../icons/24/config.svg';
import { ReactComponent as IconControls24 } from '../../icons/24/controls.svg';
import { ReactComponent as IconCopyLink24 } from '../../icons/24/copy-link.svg';
import { ReactComponent as IconCopy24 } from '../../icons/24/copy.svg';
import { ReactComponent as IconCsv24 } from '../../icons/24/csv.svg';
import { ReactComponent as IconDashboard24 } from '../../icons/24/dashboard.svg';
import { ReactComponent as IconDate24 } from '../../icons/24/date.svg';
import { ReactComponent as IconDelete24 } from '../../icons/24/delete.svg';
import { ReactComponent as IconDeselectAll24 } from '../../icons/24/deselect-all.svg';
import { ReactComponent as IconDownArrow24 } from '../../icons/24/down-arrow.svg';
import { ReactComponent as IconDownload24 } from '../../icons/24/download.svg';
import { ReactComponent as IconDrag24 } from '../../icons/24/drag.svg';
import { ReactComponent as IconEdit24 } from '../../icons/24/edit.svg';
import { ReactComponent as IconErrorStatus24 } from '../../icons/24/error_status.svg';
import { ReactComponent as IconExpand24 } from '../../icons/24/expand.svg';
import { ReactComponent as IconExports24 } from '../../icons/24/exports.svg';
import { ReactComponent as IconExternalLink24 } from '../../icons/24/external-link.svg';
import { ReactComponent as IconEyeHide24 } from '../../icons/24/eye-hide.svg';
import { ReactComponent as IconEyeShow24 } from '../../icons/24/eye-show.svg';
import { ReactComponent as IconFacebook24 } from '../../icons/24/facebook.svg';
import { ReactComponent as IconFile24 } from '../../icons/24/file.svg';
import { ReactComponent as IconFilterList24 } from '../../icons/24/filter-list.svg';
import { ReactComponent as IconFilterSliders24 } from '../../icons/24/filter-sliders.svg';
import { ReactComponent as IconFilters24 } from '../../icons/24/filters.svg';
import { ReactComponent as IconFlag24 } from '../../icons/24/flag.svg';
import { ReactComponent as IconFolder24 } from '../../icons/24/folder.svg';
import { ReactComponent as IconGraph24 } from '../../icons/24/graph.svg';
import { ReactComponent as IconHandGrab24 } from '../../icons/24/hand-grab.svg';
import { ReactComponent as IconHome24 } from '../../icons/24/home.svg';
import { ReactComponent as IconHorizontalEllipsis24 } from '../../icons/24/horizontal-ellipsis.svg';
import { ReactComponent as IconInfo24 } from '../../icons/24/info.svg';
import { ReactComponent as IconInfoStatus24 } from '../../icons/24/info_status.svg';
import { ReactComponent as IconLeftArrow24 } from '../../icons/24/left-arrow.svg';
import { ReactComponent as IconLinkedin24 } from '../../icons/24/linkedin.svg';
import { ReactComponent as IconListAdd24 } from '../../icons/24/list-add.svg';
import { ReactComponent as IconListCheck24 } from '../../icons/24/list-check.svg';
import { ReactComponent as IconList24 } from '../../icons/24/list.svg';
import { ReactComponent as IconLock24 } from '../../icons/24/lock.svg';
import { ReactComponent as IconLogOut24 } from '../../icons/24/log-out.svg';
import { ReactComponent as IconMail24 } from '../../icons/24/mail.svg';
import { ReactComponent as IconMenu24 } from '../../icons/24/menu.svg';
import { ReactComponent as IconMerge24 } from '../../icons/24/merge.svg';
import { ReactComponent as IconMinus24 } from '../../icons/24/minus.svg';
import { ReactComponent as IconMoreInfo24 } from '../../icons/24/more-info.svg';
import { ReactComponent as IconNotes24 } from '../../icons/24/notes.svg';
import { ReactComponent as IconNotifications24 } from '../../icons/24/notifications.svg';
import { ReactComponent as IconNothingToReview24 } from '../../icons/24/nothing-to-review.svg';
import { ReactComponent as IconPencil24 } from '../../icons/24/pencil.svg';
import { ReactComponent as IconPlusCircle24 } from '../../icons/24/plus-circle.svg';
import { ReactComponent as IconPlus24 } from '../../icons/24/plus.svg';
import { ReactComponent as IconRedo24 } from '../../icons/24/redo.svg';
import { ReactComponent as IconRefresh24 } from '../../icons/24/refresh.svg';
import { ReactComponent as IconRightArrow24 } from '../../icons/24/right-arrow.svg';
import { ReactComponent as IconSave24 } from '../../icons/24/save.svg';
import { ReactComponent as IconSearch24 } from '../../icons/24/search.svg';
import { ReactComponent as IconSelectAll24 } from '../../icons/24/select-all.svg';
import { ReactComponent as IconSettings24 } from '../../icons/24/settings.svg';
import { ReactComponent as IconShare24 } from '../../icons/24/share.svg';
import { ReactComponent as IconSortAsc24 } from '../../icons/24/sort-asc.svg';
import { ReactComponent as IconSortDes24 } from '../../icons/24/sort-des.svg';
import { ReactComponent as IconSort24 } from '../../icons/24/sort.svg';
import { ReactComponent as IconStarFilled24 } from '../../icons/24/star-filled.svg';
import { ReactComponent as IconStarUnfilled24 } from '../../icons/24/star-unfilled.svg';
import { ReactComponent as IconSuccessStatus24 } from '../../icons/24/success_status.svg';
import { ReactComponent as IconSwitchAcc24 } from '../../icons/24/switch-acc.svg';
import { ReactComponent as IconTag24 } from '../../icons/24/tag.svg';
import { ReactComponent as IconUnarchive24 } from '../../icons/24/unarchive.svg';
import { ReactComponent as IconUnlock24 } from '../../icons/24/unlock.svg';
import { ReactComponent as IconUpArrow24 } from '../../icons/24/up-arrow.svg';
import { ReactComponent as IconUpload24 } from '../../icons/24/upload.svg';
import { ReactComponent as IconUserAttribute24 } from '../../icons/24/user-attribute.svg';
import { ReactComponent as IconUserCircle24 } from '../../icons/24/user-circle.svg';
import { ReactComponent as IconUserMinus24 } from '../../icons/24/user-minus.svg';
import { ReactComponent as IconUserPlus24 } from '../../icons/24/user-plus.svg';
import { ReactComponent as IconUser24 } from '../../icons/24/user.svg';
import { ReactComponent as IconUsersGroup24 } from '../../icons/24/users-group.svg';
import { ReactComponent as IconVerticalEllipsis24 } from '../../icons/24/vertical-ellipsis.svg';
import { ReactComponent as IconWarningStatus24 } from '../../icons/24/warning_status.svg';
import { ReactComponent as IconWindfall24 } from '../../icons/24/windfall.svg';
import { ReactComponent as IconX24 } from '../../icons/24/x.svg';
import { ReactComponent as IconErrorStatus32 } from '../../icons/32/error_status.svg';
import { ReactComponent as IconInfoStatus32 } from '../../icons/32/info_status.svg';
import { ReactComponent as IconSavedToCrm32 } from '../../icons/32/saved-to-crm.svg';
import { ReactComponent as IconSuccessStatus32 } from '../../icons/32/success_status.svg';
import { ReactComponent as IconWarningStatus32 } from '../../icons/32/warning_status.svg';
import { ReactComponent as IconAiReport36 } from '../../icons/36/icon_ai_report.svg'
import { ReactComponent as IconAiReportTeal36 } from '../../icons/36/icon_ai_report_teal.svg'
import { ReactComponent as IconCustomReport36 } from '../../icons/36/icon_custom_report.svg'
import { ReactComponent as IconJobUpdates36 } from '../../icons/36/job-updates.svg'
import { ReactComponent as IconNewsfeed36 } from '../../icons/36/newsfeed.svg'
import { ReactComponent as IconSecFilings36 } from '../../icons/36/sec-filings.svg'
const icons = {
  "14": {
    "lock": IconLock14,
  },
  "16": {
    "archive": IconArchive16,
    "bookmark": IconBookmark16,
    "boost": IconBoost16,
    "check": IconCheck16,
    "chevron-down": IconChevronDown16,
    "chevron-left": IconChevronLeft16,
    "chevron-right": IconChevronRight16,
    "chevron-up": IconChevronUp16,
    "clock": IconClock16,
    "close": IconClose16,
    "columns": IconColumns16,
    "comment": IconComment16,
    "config": IconConfig16,
    "controls": IconControls16,
    "copy-link": IconCopyLink16,
    "copy": IconCopy16,
    "csv": IconCsv16,
    "dashboard": IconDashboard16,
    "date": IconDate16,
    "delete": IconDelete16,
    "deselect-all": IconDeselectAll16,
    "down-arrow": IconDownArrow16,
    "download": IconDownload16,
    "drag": IconDrag16,
    "edit": IconEdit16,
    "error_status": IconErrorStatus16,
    "expand": IconExpand16,
    "exports": IconExports16,
    "external-link": IconExternalLink16,
    "eye-hide": IconEyeHide16,
    "eye-show": IconEyeShow16,
    "file": IconFile16,
    "filter-list": IconFilterList16,
    "filter-sliders": IconFilterSliders16,
    "filters": IconFilters16,
    "flag": IconFlag16,
    "folder": IconFolder16,
    "graph": IconGraph16,
    "hand-grab": IconHandGrab16,
    "home": IconHome16,
    "horizontal-ellipsis": IconHorizontalEllipsis16,
    "info": IconInfo16,
    "info_status": IconInfoStatus16,
    "left-arrow": IconLeftArrow16,
    "linkedin": IconLinkedin16,
    "list-add": IconListAdd16,
    "list-check": IconListCheck16,
    "list": IconList16,
    "lock": IconLock16,
    "log-out": IconLogOut16,
    "mail": IconMail16,
    "mapper-suggestions": IconMapperSuggestions16,
    "menu": IconMenu16,
    "merge": IconMerge16,
    "minus": IconMinus16,
    "more-info": IconMoreInfo16,
    "notes": IconNotes16,
    "notifications": IconNotifications16,
    "pencil": IconPencil16,
    "plus-circle": IconPlusCircle16,
    "plus": IconPlus16,
    "redo": IconRedo16,
    "refresh": IconRefresh16,
    "right-arrow": IconRightArrow16,
    "roles-permissions": IconRolesPermissions16,
    "save": IconSave16,
    "search": IconSearch16,
    "select-all": IconSelectAll16,
    "settings": IconSettings16,
    "share": IconShare16,
    "sort-asc": IconSortAsc16,
    "sort-des": IconSortDes16,
    "sort": IconSort16,
    "star-filled": IconStarFilled16,
    "star-unfilled": IconStarUnfilled16,
    "success_status": IconSuccessStatus16,
    "suitcase": IconSuitcase16,
    "switch-acc": IconSwitchAcc16,
    "tag": IconTag16,
    "team-outbound": IconTeamOutbound16,
    "team-premium": IconTeamPremium16,
    "team-unverified": IconTeamUnverified16,
    "team-verified": IconTeamVerified16,
    "unarchive": IconUnarchive16,
    "unmap": IconUnmap16,
    "unlock": IconUnlock16,
    "up-arrow": IconUpArrow16,
    "upload": IconUpload16,
    "user-attribute": IconUserAttribute16,
    "user-circle": IconUserCircle16,
    "user-minus": IconUserMinus16,
    "user-plus": IconUserPlus16,
    "user": IconUser16,
    "users-group": IconUsersGroup16,
    "vertical-ellipsis": IconVerticalEllipsis16,
    "warning": IconWarning16,
    "warning_status": IconWarningStatus16,
    "windfall": IconWindfall16,
    "facebook": IconFacebook16,
    "x": IconX16,
  },
  "20": {
    "archive": IconArchive20,
    "bookmark": IconBookmark20,
    "boost": IconBoost20,
    "check": IconCheck20,
    "chevron-down": IconChevronDown20,
    "chevron-left": IconChevronLeft20,
    "chevron-right": IconChevronRight20,
    "chevron-up": IconChevronUp20,
    "clock": IconClock20,
    "close": IconClose20,
    "columns": IconColumns20,
    "comment": IconComment20,
    "config": IconConfig20,
    "controls": IconControls20,
    "copy": IconCopy20,
    "copy-link": IconCopyLink20,
    "dashboard": IconDashboard20,
    "date": IconDate20,
    "delete": IconDelete20,
    "down-arrow": IconDownArrow20,
    "download": IconDownload20,
    "drag": IconDrag20,
    "edit": IconEdit20,
    "expand": IconExpand20,
    "exports": IconExports20,
    "external-link": IconExternalLink20,
    "eye-hide": IconEyeHide20,
    "eye-show": IconEyeShow20,
    "file": IconFile20,
    "filter-list": IconFilterList20,
    "filters": IconFilters20,
    "filter-sliders": IconFilterSliders20,
    "flag": IconFlag20,
    "folder": IconFolder20,
    "graph": IconGraph20,
    "hand-grab": IconHandGrab20,
    "home": IconHome20,
    "horizontal-ellipsis": IconHorizontalEllipsis20,
    "left-arrow": IconLeftArrow20,
    "list": IconList20,
    "list-add": IconListAdd20,
    "list-check": IconListCheck20,
    "lock": IconLock20,
    "log-out": IconLogOut20,
    "mail": IconMail20,
    "menu": IconMenu20,
    "merge": IconMerge20,
    "minus": IconMinus20,
    "more-info": IconMoreInfo20,
    "notes": IconNotes20,
    "notifications": IconNotifications20,
    "pencil": IconPencil20,
    "plus": IconPlus20,
    "plus-circle": IconPlusCircle20,
    "redo": IconRedo20,
    "refresh": IconRefresh20,
    "right-arrow": IconRightArrow20,
    "save": IconSave20,
    "search": IconSearch20,
    "settings": IconSettings20,
    "share": IconShare20,
    "sort": IconSort20,
    "sort-asc": IconSortAsc20,
    "sort-des": IconSortDes20,
    "star-filled": IconStarFilled20,
    "star-unfilled": IconStarUnfilled20,
    "switch-acc": IconSwitchAcc20,
    "tag": IconTag20,
    "unarchive": IconUnarchive20,
    "unlock": IconUnlock20,
    "up-arrow": IconUpArrow20,
    "upload": IconUpload20,
    "user": IconUser20,
    "user-circle": IconUserCircle20,
    "user-minus": IconUserMinus20,
    "user-plus": IconUserPlus20,
    "users-group": IconUsersGroup20,
    "vertical-ellipsis": IconVerticalEllipsis20,
  },
  "24": {
    "archive": IconArchive24,
    "bookmark": IconBookmark24,
    "boost": IconBoost24,
    "check": IconCheck24,
    "chevron-down": IconChevronDown24,
    "chevron-left": IconChevronLeft24,
    "chevron-right": IconChevronRight24,
    "chevron-up": IconChevronUp24,
    "clock": IconClock24,
    "close": IconClose24,
    "columns": IconColumns24,
    "comment": IconComment24,
    "config": IconConfig24,
    "controls": IconControls24,
    "copy-link": IconCopyLink24,
    "copy": IconCopy24,
    "csv": IconCsv24,
    "dashboard": IconDashboard24,
    "date": IconDate24,
    "delete": IconDelete24,
    "deselect-all": IconDeselectAll24,
    "down-arrow": IconDownArrow24,
    "download": IconDownload24,
    "drag": IconDrag24,
    "edit": IconEdit24,
    "error_status": IconErrorStatus24,
    "expand": IconExpand24,
    "exports": IconExports24,
    "external-link": IconExternalLink24,
    "eye-hide": IconEyeHide24,
    "eye-show": IconEyeShow24,
    "facebook": IconFacebook24,
    "file": IconFile24,
    "filter-list": IconFilterList24,
    "filter-sliders": IconFilterSliders24,
    "filters": IconFilters24,
    "flag": IconFlag24,
    "folder": IconFolder24,
    "graph": IconGraph24,
    "hand-grab": IconHandGrab24,
    "home": IconHome24,
    "horizontal-ellipsis": IconHorizontalEllipsis24,
    "info": IconInfo24,
    "info_status": IconInfoStatus24,
    "left-arrow": IconLeftArrow24,
    "linkedin": IconLinkedin24,
    "list-add": IconListAdd24,
    "list-check": IconListCheck24,
    "list": IconList24,
    "lock": IconLock24,
    "log-out": IconLogOut24,
    "mail": IconMail24,
    "menu": IconMenu24,
    "merge": IconMerge24,
    "minus": IconMinus24,
    "more-info": IconMoreInfo24,
    "notes": IconNotes24,
    "notifications": IconNotifications24,
    "nothing-to-review": IconNothingToReview24,
    "pencil": IconPencil24,
    "plus-circle": IconPlusCircle24,
    "plus": IconPlus24,
    "redo": IconRedo24,
    "refresh": IconRefresh24,
    "right-arrow": IconRightArrow24,
    "save": IconSave24,
    "search": IconSearch24,
    "select-all": IconSelectAll24,
    "settings": IconSettings24,
    "share": IconShare24,
    "sort-asc": IconSortAsc24,
    "sort-des": IconSortDes24,
    "sort": IconSort24,
    "star-filled": IconStarFilled24,
    "star-unfilled": IconStarUnfilled24,
    "success_status": IconSuccessStatus24,
    "switch-acc": IconSwitchAcc24,
    "tag": IconTag24,
    "unarchive": IconUnarchive24,
    "unlock": IconUnlock24,
    "up-arrow": IconUpArrow24,
    "upload": IconUpload24,
    "user-attribute": IconUserAttribute24,
    "user-circle": IconUserCircle24,
    "user-minus": IconUserMinus24,
    "user-plus": IconUserPlus24,
    "user": IconUser24,
    "users-group": IconUsersGroup24,
    "vertical-ellipsis": IconVerticalEllipsis24,
    "warning_status": IconWarningStatus24,
    "windfall": IconWindfall24,
    "x": IconX24,
  },
  "32": {
    "error_status": IconErrorStatus32,
    "info_status": IconInfoStatus32,
    "saved-to-crm": IconSavedToCrm32,
    "success_status": IconSuccessStatus32,
    "warning_status": IconWarningStatus32,
  },
  "36": {
    "job-updates": IconJobUpdates36,
    "newsfeed": IconNewsfeed36,
    "sec-filings": IconSecFilings36,
    "IconAiReport": IconAiReport36,
    "IconAiReportTeal": IconAiReportTeal36,
    "IconCustomReport": IconCustomReport36,
    "ai-report": IconAiReport36,
    "ai-report-teal": IconAiReportTeal36,
    "custom-report": IconCustomReport36,
  },
};


/**
 * Icon generator for the new Design System.
 * Supports sizes 14, 16, 20, 24, 32, and 36.
 * Falls back to size 24 if the requested size is not found.
 */
export const Icons = ({ name, size = 24, ...props }) => {
  const iconCollection = icons[String(size)] || icons["24"];
  const IconComponent = iconCollection[name];

  if (!IconComponent) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(`DesignSystem Icon: Could not find icon "${name}" in size "${size}".`);
    }
    return <div style={{ width: size, height: size, display: 'inline-block' }} />;
  }

  return (
    <Suspense fallback={<div style={{ width: size, height: size }} />}>
      <IconComponent name={name} width={size} height={size} {...props} />
    </Suspense>
  );
};

export default Icons;
